import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable()
export class DataTransferService {
  addLocation = new BehaviorSubject<any>('initialState');
  editLocation = new BehaviorSubject<any>('initialState');
  passLocation = new BehaviorSubject<any>('initialState');
  tripDetails = new BehaviorSubject<any>('');
  countLocation = new BehaviorSubject<any>('0');
  currentUser = new BehaviorSubject<any>('0');
  editUser = new BehaviorSubject<any>('0');

  constructor() { }

  updateAddLocation(event) {
    this.addLocation.next(event);
  }

  getAddLocation() {
    return this.addLocation.asObservable();
  }

  updatePassLocation(event) {
    this.passLocation.next(event);
  }

  passSpeakerCount(event) {
    this.countLocation.next(event);
  }

  getCountSpeaker() {
    return this.countLocation.asObservable();
  }

  getPassLocation() {
    return this.passLocation.asObservable();
  }

  updateEditLocation(event) {
    this.editLocation.next(event);
  }

  getEditLocation() {
    return this.editLocation.asObservable();
  }

  updateTripDetails(event) {
    this.tripDetails.next(event);
  }

  getTripDetails() {
    return this.tripDetails.asObservable();
  }

  intialiseTripDetails() {
    this.tripDetails.next('');
  }

  getCurrentUser() {
    return this.currentUser.asObservable();
  }

  updateCurrentUser(event) {
    this.currentUser.next(event);
  }

  getEditUser() {
    return this.editUser.asObservable();
  }

  updateEditUser(event) {
    this.editUser.next(event);
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/MileTrack-Frontend-AWS-S3/src/app/core/services/data-transfer.service.ts